<div class="video-instruction-card">
  <div class="title">
    <gc-text [variant]="'paragraphHeading'">{{ instruction().title }}</gc-text>
  </div>
  <div class="video">
    @if (safeEmbedUrl(); as embedUrl) {
      <iframe
        width="560"
        height="315"
        [src]="safeEmbedUrl()"
        title="YouTube video player"
        allow="compute-pressure"
        allowfullscreen
      ></iframe>
    }
  </div>
</div>
